import Button, {ButtonVariant} from 'bitmovin-web-ui/src/components/core/button';
import React from 'react';
import Carousel from 'react-slick';
import styled from 'styled-components';

import {pxToEm} from './globalStyles';

//#region Styled Components

/** Slider css file copied into Styled Component wrapper to avoid including of *.css file,
 * aka. css-loader for webpack config
 */
const StyledCarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  .slick-slider {
    position: relative;

    display: block;
    box-sizing: border-box;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list {
    position: relative;

    display: block;
    overflow: hidden;

    margin: 0;
    padding: 0;
  }
  .slick-list:focus {
    outline: none;
  }
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }
  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;

    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .slick-track:before,
  .slick-track:after {
    display: table;

    content: '';
  }
  .slick-track:after {
    clear: both;
  }
  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;

    height: 100%;
    min-height: ${pxToEm(1)}em;
  }
  [dir='rtl'] .slick-slide {
    float: right;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-initialized .slick-slide {
    display: block;
  }
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  .slick-vertical .slick-slide {
    display: block;

    height: auto;

    border: ${pxToEm(1)}em solid transparent;
  }
  .slick-arrow.slick-hidden {
    display: none;
  }

  /* Arrows */
  .slick-prev,
  .slick-next {
    font-size: 0;
    line-height: 0;

    position: absolute;
    top: 50%;

    display: block;

    width: ${pxToEm(20)}em;
    height: ${pxToEm(20)}em;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);

    cursor: pointer;

    color: transparent;
    border: none;
    outline: none;
    background: transparent;
  }
  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    color: transparent;
    outline: none;
    background: transparent;
  }
  .slick-prev:hover:before,
  .slick-prev:focus:before,
  .slick-next:hover:before,
  .slick-next:focus:before {
    opacity: 1;
  }
  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before {
    opacity: 0.25;
  }

  .slick-prev:before,
  .slick-next:before {
    font-family: 'slick';
    font-size: ${pxToEm(20)}em;
    line-height: 1;

    opacity: 0.75;
    color: white;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-prev {
    left: ${pxToEm(-25)}em;
  }
  [dir='rtl'] .slick-prev {
    right: ${pxToEm(-25)}em;
    left: auto;
  }
  .slick-prev:before {
    content: '←';
  }
  [dir='rtl'] .slick-prev:before {
    content: '→';
  }

  .slick-next {
    right: ${pxToEm(-25)}em;
  }
  [dir='rtl'] .slick-next {
    right: auto;
    left: ${pxToEm(-25)}em;
  }
  .slick-next:before {
    content: '→';
  }
  [dir='rtl'] .slick-next:before {
    content: '←';
  }

  /* Dots */
  .slick-dotted.slick-slider {
    margin-bottom: ${pxToEm(30)}em;
  }

  .slick-dots {
    position: absolute;
    bottom: ${pxToEm(-25)}em;

    display: block;

    width: 100%;
    padding: 0;
    margin: 0;

    list-style: none;

    text-align: center;
  }
  .slick-dots li {
    position: relative;

    display: inline-block;

    width: ${pxToEm(20)}em;
    height: ${pxToEm(20)}em;
    margin: 0 ${pxToEm(5)}em;
    padding: 0;

    cursor: pointer;
  }
  .slick-dots li button {
    font-size: 0;
    line-height: 0;

    display: block;

    width: ${pxToEm(20)}em;
    height: ${pxToEm(20)}em;
    padding: ${pxToEm(5)}em;

    cursor: pointer;

    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }
  .slick-dots li button:hover,
  .slick-dots li button:focus {
    outline: none;
  }
  .slick-dots li button:hover:before,
  .slick-dots li button:focus:before {
    opacity: 1;
  }
  .slick-dots li button:before {
    font-family: 'slick';
    font-size: ${pxToEm(6)}em;
    line-height: ${pxToEm(20)}em;

    position: absolute;
    top: 0;
    left: 0;

    width: ${pxToEm(20)}em;
    height: ${pxToEm(20)}em;

    content: '•';
    text-align: center;

    opacity: 0.25;
    color: black;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: black;
  }
`;

const StyledButton = styled(Button)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  text-align: center;
  min-width: unset !important;
  width: ${pxToEm(35)}em;
  height: ${pxToEm(35)}em;
  border-radius: ${pxToEm(17.5)}em !important;
  padding: 0 !important;
  margin: 0 ${pxToEm(12)}em;
  z-index: 2;

  :focus {
    outline: none;
  }

  > svg {
    margin-left: 0.5em;
  }
`;

const StyledPrevButton = styled(StyledButton)`
  left: 0;
`;

const StyledNextButton = styled(StyledButton)`
  right: 0;
`;

//#endregion

const CarouselSlider: React.FunctionComponent<Carousel> = props => {
  const carouselRef = React.createRef<any>();

  return (
    <StyledCarouselWrapper className={props.className}>
      <StyledPrevButton variant={ButtonVariant.OutlinedLight} onClick={() => carouselRef.current.slickPrev()}>
        {'<'}
      </StyledPrevButton>
      <StyledNextButton variant={ButtonVariant.OutlinedLight} onClick={() => carouselRef.current.slickNext()}>
        {'>'}
      </StyledNextButton>

      <Carousel ref={carouselRef} carouselRef={carouselRef} {...props}>
        {props.children}
      </Carousel>
    </StyledCarouselWrapper>
  );
};

export default CarouselSlider;
